export type FlexAlignmentProperties = 'flex-start' | 'flex-end' | 'center' | 'stretch';

export type HeadingElements = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export enum ID {
  NEXT = '__next',
  CONTENT = 'content'
}
